module.exports = __webpack_public_path__ + "be.8e6fc60f.svg";